module.exports = __webpack_public_path__ + "static/media/house_small.5eac5739.png";